import {
  AIIcon,
  SyntheticDataGenerationIcon,
  AwsIcon,
  BlockchainIcon,
  DefiIcon,
  FintechIcon,
  MobileIcon,
  RustWebAppIcon,
  SmartContractIcon,
  StellarIcon,
  WebIcon,
  XRPLIcon,
  ZeroKnowledgeProofIcon,
  AIKnowledgeManagementSolutionsIcon,
} from '../Icons';
import { SubmenuBlockProps } from '../SubmenuBlock/SubmenuBlock.types';

export const servicesSubmenuData: {
  category: string;
  services: SubmenuBlockProps[];
}[] = [
  {
    category: 'Blockchain Development',
    services: [
      {
        name: 'Blockchain Software Development',
        caption:
          'Grow your business with our blockchain software development services',
        icon: BlockchainIcon,
        linkTo: '/services/blockchain-software-development/',
      },
      {
        name: 'Zero-Knowledge Proof Development',
        caption: 'Building privacy-preserving blockchain solutions that scale',
        icon: ZeroKnowledgeProofIcon,
        linkTo: '/services/zero-knowledge-proof-development/',
      },
      {
        name: 'XRPL Blockchain Development Services',
        caption: 'Enterprise-grade blockchain development for XRP Ledger',
        icon: XRPLIcon,
        linkTo: '/services/xrpl-blockchain-development/',
      },
      {
        name: 'Stellar Product Development Services',
        caption: 'Fast, compliant product development on the Stellar network',
        icon: StellarIcon,
        linkTo: '/services/stellar-product-development/',
      },
      {
        name: 'Smart Contract Development',
        caption: 'We turn your business logic into bulletproof blockchain code',
        icon: SmartContractIcon,
        linkTo: '/services/smart-contract-development/',
      },
      {
        name: 'DeFi Development',
        caption: 'Bringing you custom DeFi product development from A to Z ',
        icon: DefiIcon,
        linkTo: '/services/defi-development/',
      },
    ],
  },
  {
    category: 'AI Development',
    services: [
      {
        name: 'AI Chat Assistant Development',
        caption: 'Develop your custom AI chatbot with our team of AI experts',
        icon: AIIcon,
        linkTo: '/services/ai-chat-assistant/',
      },
      {
        name: 'Synthetic Data Generation',
        caption:
          'Custom Synthetic Data Solutions for Complex Product Challenges',
        icon: SyntheticDataGenerationIcon,
        linkTo: '/services/synthetic-data-generation/',
      },
      {
        name: 'AI Knowledge Management Solutions',
        caption:
          'Custom AI Solutions That Transform Scattered Knowledge into Strategic Intelligence',
        icon: AIKnowledgeManagementSolutionsIcon,
        linkTo: '/services/ai-knowledge-management-solutions/',
      },
    ],
  },
  {
    category: 'Software Development',
    services: [
      {
        name: 'AWS Cloud Solutions',
        caption: 'Creative AWS cloud solutions to elevate your business',
        icon: AwsIcon,
        linkTo: '/services/aws-cloud-solutions/',
      },
      {
        name: 'Fintech Software Development',
        caption:
          'Boost your financial product with state-of-the-art technology',
        icon: FintechIcon,
        linkTo: '/services/fintech-software-development/',
      },
      {
        name: 'Web development',
        caption:
          'Sleek front-end and powerful back-end to make your website pop',
        icon: WebIcon,
        linkTo: '/services/web-development/',
      },
      {
        name: 'Mobile development',
        caption: 'Custom end-to-end IOS and Android app development',
        icon: MobileIcon,
        linkTo: '/services/mobile-development/',
      },
      {
        name: 'Rust Web App Development',
        caption: 'Build Lightning-Fast Web Applications with Rust',
        icon: RustWebAppIcon,
        linkTo: '/services/rust-web-app-development/',
      },
    ],
  },
];
